import { Component } from '@angular/core';

@Component({
  selector: 'll-exam-sections-occupancy',
  templateUrl: './ll-exam-sections-occupancy.component.html',
  styleUrl: './ll-exam-sections-occupancy.component.css'
})
export class LlExamSectionsOccupancyComponent {

}
